 var featuredCollection = new Swiper(".featuredCollection", {
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        nextEl: ".slide-button-next-products",
        prevEl: ".slide-button-prev-products",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1224: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });

window.variantThumbnails = new Swiper('.variant-thumbnails', {
  slidesPerView: 5,
  watchSlidesProgress: true,
});

window.variantImages = new Swiper('.variant-images', {
  spaceBetween: 10,
  navigation: {
    nextEl: ".variant-images .swiper-button-next",
    prevEl: ".variant-images .swiper-button-prev",
  },
  thumbs: {
    swiper: window.variantThumbnails,
  },
});


   var swiper2 = new Swiper(".mySwiper", {
        slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });


    var swiper3 = new Swiper(".howMade", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1224: {
          slidesPerView: 5,
          spaceBetween: 0,
        },
      },
    });





var swiper5 = new Swiper(".annoucementBar", {
      slidesPerView: 1,
      spaceBetween: 20,
  navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  loop: true,
  autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
  breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1224: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
